import type { RefereeAssignmentResponse } from '@1webit/cvs-api-scheme/models/refereeAssignmentResponse';

export enum RefereeMatchDetailFormColor {
  AVAILABLE = '',
  UNAVAILABLE = 'text-violet-500',
  HASMATCH = 'text-red-500',
  VETOED = 'text-blue-400',
  NOEMAIL = 'text-green-500',
}

export type RefereeMatchDetailFormState = Pick<RefereeAssignmentResponse, 'hasMatch' | 'isUnavailable' | 'isVetoed' | 'hasNoEmail'>;

export const refereeStateToColor = (refereeState: RefereeMatchDetailFormState): RefereeMatchDetailFormColor => {
  if (refereeState.isUnavailable) {
    return RefereeMatchDetailFormColor.UNAVAILABLE;
  }
  if (refereeState.hasMatch) {
    return RefereeMatchDetailFormColor.HASMATCH;
  }
  if (refereeState.isVetoed) {
    return RefereeMatchDetailFormColor.VETOED;
  }

  if (refereeState.hasNoEmail) {
    return RefereeMatchDetailFormColor.NOEMAIL;
  }

  return RefereeMatchDetailFormColor.AVAILABLE;
};
